import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getWishlistProducts } from "../../../../redux/reduxApi/website/WishlistApi";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import ProductCard from "../../shop/ProdCard";
import { FaHandHoldingHeart } from "react-icons/fa";
import { getShadeNumberList } from "../../../../redux/reduxApi/admin/ShadeReduxApi";

import Heading from "../../utils/Heading.jsx";

export default function Wishlist() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [matchedProducts, setMatchedProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Get wishlist data from Redux store
  const wishlistData = useSelector(
    (state) => state.Wishlist?.wishlist || []
  );
  console.log("Wishlist Data:", wishlistData);

  // Get shade data from Redux store - already an array
  const getShadeNumberData = useSelector((state) => state?.shade?.shade || []);
  console.log("Shade Number Data:", getShadeNumberData);

  // Fetch shade number list
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setIsLoading(true);
        await dispatch(getShadeNumberList());
      } catch (error) {
        console.error("Error fetching Product data:", error);
      }
    };

    fetchProducts();
  }, [dispatch]);

  // Fetch wishlist
  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        setIsLoading(true);
        await dispatch(getWishlistProducts());
      } catch (error) {
        console.error("Error fetching wishlist:", error);
      }
    };

    fetchWishlist();
  }, [dispatch]);

  // Match wishlist items with shade data
  useEffect(() => {
    if (wishlistData.length > 0 && getShadeNumberData.length > 0) {
      // Extract wishListItem IDs from wishlist data
      const wishlistItemIds = wishlistData
        .map((item) => item.wishLists?.wishListItem)
        .filter((id) => id && id !== null);

      console.log("Wishlist Item IDs:", wishlistItemIds);
      console.log(
        "Available Shade ROWIDs:",
        getShadeNumberData.map((shade) => shade.ROWID),
      );

      // Find matching shades from getShadeNumberData
      const matched = getShadeNumberData.filter((shade) =>
        wishlistItemIds.includes(shade.ROWID),
      );

      console.log("Matched Products:", matched);
      setMatchedProducts(matched);
      setIsLoading(false);
    } else if (wishlistData.length === 0) {
      setMatchedProducts([]);
      setIsLoading(false);
    }
  }, [wishlistData, getShadeNumberData]);

  const text = "Wishlist";

  // Show loading state
  if (isLoading) {
    return (
      <div className="w-full md:pl-2 md:mt-0 py-[0px]">
        <div className="relative flex items-center justify-center lg:!mt-0 md:mt-7 mt-4 mb-4">
          <Link to="/account/dashboard" className="absolute left-0">
            <FaArrowLeft size="20px" />
          </Link>
          <div className="text-center">
            <Heading text={<span className="inline-flex items-center gap-2">Wishlist <FaHandHoldingHeart className="text-[#661e33] lg:text-4xl md:text-3xl text-2xl" /></span>} />
            <hr className="heading-seperator border-t-4 border-[#66944b] opacity-100 w-24 h-4 mx-auto" />
          </div>
        </div>

        {/* Loading Message */}
        <div className="flex flex-col items-center justify-center py-20">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[brown] mb-4"></div>
          <p className="text-gray-500 text-lg">Loading product details...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="w-full md:pl-2 md:mt-0 py-[0px]">
        <div className="relative flex items-center justify-center lg:!mt-0 md:mt-7 mt-4 mb-1">
          <Link to="/account/dashboard" className="absolute left-0">
            <FaArrowLeft size="20px" />
          </Link>

          <div className="text-center">
            <Heading text={<span className="inline-flex items-center gap-2">Wishlist <FaHandHoldingHeart className="text-[#661e33] lg:text-4xl md:text-3xl text-2xl" /></span>} />
            <hr className="heading-seperator border-t-4 border-[#66944b] opacity-100 w-24 h-4 mx-auto" />
          </div>
        </div>

        {/* Display matched products */}
        {matchedProducts.length > 0 ? (
          <div className="grid w-full mx-auto px-1 sm:px-0
grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4
gap-y-6 sm:gap-y-4
gap-x-4 lg:gap-x-12 lg:max-h-[595px] lg:overflow-y-auto lg:pt-2">
            {matchedProducts.map((product, idx) => (
              <ProductCard key={idx} product={product} />
            ))}
          </div>
        ) : (
          <div className="text-center py-10">
            {wishlistData.length > 0 ? (
              <>
                <p className="text-gray-500">Loading product details...</p>
                <p className="text-gray-400 text-sm mt-2">
                  Matching {wishlistData.length} wishlist items with{" "}
                  {getShadeNumberData.length} products...
                </p>
              </>
            ) : (
              <div className="flex flex-col items-center">
                <FaHandHoldingHeart className="text-gray-300 text-6xl mb-4" />
                <p className="text-gray-500 text-lg">
                  No products in wishlist.
                </p>
                <button
                  onClick={() => navigate("/shop")}
                  className="mt-4 px-6 py-2 bg-[brown] text-white rounded-lg hover:bg-opacity-90 transition"
                >
                  Continue Shopping
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      <style>
        {`
          .product-card {
            position: relative;
          }
          .product-card .heart-icon {
            opacity: 0;
            transition: opacity 0.3s;
            position: absolute;
            top: 10px;
            right: 10px;
          }
          .product-card:hover .heart-icon {
            opacity: 1;
          }
        `}
      </style>
    </>
  );
}

